import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { getContrastThemeClass, resolveBackgroundStyle } from '@gn-audio/jss-components';

import { Slider } from './Slider';
import { SliderSpotProps } from './sliderTypes';

const SliderSpot = ({ fields }: SliderSpotProps): React.ReactElement | null => {
  const { header, cards, background, centerWhenNotScrollable } = fields;
  const spotThemeClass = getContrastThemeClass(background?.value as string);
  const spotBackgroundStyle = resolveBackgroundStyle(background?.value as string);

  return (
    <div style={spotBackgroundStyle} className="container-fluid overflow-hidden">
      <div className="container !py-0">
        <Slider
          header={header}
          cards={cards}
          centerWhenNotScrollable={centerWhenNotScrollable}
          spotThemeClass={spotThemeClass}
        />
      </div>
    </div>
  );
};

export default withDatasourceCheck()<SliderSpotProps>(SliderSpot);
